import React from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Spinner } from 'react-bootstrap';

const FALLBACK_MESSAGES = {
  MISSING_ID_IMAGE: 'ID document not uploaded.',
  MISSING_LICENSE: 'Professional license missing or incomplete.',
  MISSING_EDUCATION: 'At least one education record is required.',
};

/**
 * @param {{
 *   checking: boolean,
 *   checked: boolean,
 *   valid: boolean,
 *   blockingMessage?: string|null,
 *   errors?: Array<{ code: string, detail?: string }>,
 *   profilePath?: string,
 * }} props
 */
export default function SubmissionReadinessAlert({
  checking,
  checked,
  valid,
  blockingMessage,
  errors = [],
  profilePath = '/enduser/profile/hcp',
}) {
  if (!checked && checking) {
    return (
      <Alert
        variant="secondary"
        className="d-flex align-items-center gap-2 py-2"
      >
        <Spinner animation="border" size="sm" />
        <span>Checking mandatory profile items…</span>
      </Alert>
    );
  }

  if (!checked || valid) {
    return null;
  }

  const title =
    blockingMessage ||
    FALLBACK_MESSAGES[errors?.[0]?.code] ||
    'Please complete your profile';

  return (
    <Alert variant="danger" className="mb-3 border-2">
      <div className="fw-semibold mb-2">{title}</div>
      {errors?.length ? (
        <ul className="small mb-3 ps-3">
          {errors.map((e) => (
            <li key={e.code}>
              <span className="fw-medium">{e.code.replace(/_/g, ' ')}:</span>{' '}
              {e.detail ||
                FALLBACK_MESSAGES[e.code] ||
                'Add this on your profile, then refresh this page.'}
            </li>
          ))}
        </ul>
      ) : null}
      <Button
        as={Link}
        to={profilePath}
        variant="primary"
        size="sm"
        className="me-2"
      >
        Open HCP profile
      </Button>
      <span className="text-muted small align-middle">
        Update your profile there, then save or revisit this draft.
      </span>
    </Alert>
  );
}
